module.exports = __webpack_public_path__ + "img/nearby-event30.b543ebac.svg";